import {Room} from "@colyseus/sdk";
import {RoomStore} from "../store/room.store";
import {inject} from "@angular/core";
import {toObservable} from "@angular/core/rxjs-interop";

export abstract class AbstractMessageListenerService<T> {

  readonly roomStore = inject(RoomStore);

  protected room?: Room;

  protected constructor(private messageName: string) {
    toObservable(this.roomStore.room)
      .subscribe(room => room && this.listenTo(room));
  }

  public abstract process(message: T): void;

  private listenTo(room: Room): void {
    this.room = room;
    room.onMessage(this.messageName, (message) => {
      console.debug('received', this.messageName, message);
      this.process(message);
    });
  }
}
